module.exports = __webpack_public_path__ + "static/Crocodile-2dcdb433789f9a4d7e6ed6d68fa1544e.jpg";